import Icon from "./icon";

type DurationProps = {
  duration?: number;
  centered?: boolean;
};

export const formatDuration = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const formattedSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

  return `${minutes}:${formattedSeconds}`;
};

export const formatAccessibleDuration = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const minuteText = minutes === 1 ? "1 minut" : `${minutes} minuter`;
  const secondText =
    remainingSeconds === 1 ? "1 sekund" : `${remainingSeconds} sekunder`;

  if (minutes > 0 && remainingSeconds > 0) {
    return `${minuteText}, ${secondText}`;
  } else if (minutes > 0) {
    return minuteText;
  } else {
    return secondText;
  }
};

const Duration = (props: DurationProps) => {
  if (props.centered) {
    return (
      <div className="flex overflow-hidden top-0 left-0 items-center justify-center">
        <div className="bg-static-black lg:hover:bg-red-700 w-[32px] h-[32px] flex items-center justify-center">
          <Icon.Play className="text-static-white" aria-label="Video" />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="absolute bottom-2 left-2 overflow-hidden bg-static-black lg:hover:bg-red-700 w-[32px] h-[32px] flex items-center justify-center">
        <Icon.Play className="text-static-white" aria-label="Video" />
      </div>

      {props.duration && (
        <>
          <div
            className="absolute bottom-2 right-2 overflow-hidden text-static-white text-sm font-bold h-[32px] bg-static-black/80 flex items-center px-2"
            aria-hidden="true"
          >
            {formatDuration(props.duration)}
          </div>
          <span className="sr-only text-static-white">
            {formatAccessibleDuration(props.duration)}
          </span>
        </>
      )}
    </>
  );
};

export default Duration;
